module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Double-Shot-at-Love.6277b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Double-Shot-at-Love.jpg
// module id = bqSZ
// module chunks = 0